import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes, CanDeactivateFn } from '@angular/router';

import { NotFoundComponent } from './pages/not-found/not-found.component';
import { VideoWatchPageComponent } from './pages/video-watch-page/video-watch-page.component';
import { AnalysisComponent } from './pages/analysis/analysis.component';
import { PerformanceComponent } from './pages/performance/performance.component';
import { HealthComponent } from './pages/health/health.component';
import { UploadVideoComponent } from './pages/upload-video/upload-video.component';
import { LoginPageComponent } from './features/sso-wise-id/view/login-page/login-page.component';
import { AfterLoginComponent } from './features/sso-wise-id/view/after-login/after-login.component';
import { WiseIdAuthGuard } from './features/sso-wise-id/controller/wise-id-auth.guard';
import { PermissionGuard } from './services/permission.guard';
import { LogoutComponent } from './features/sso-wise-id/view/logout/logout.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { AdminPageComponent } from "./pages/admin-page/admin-page.component";
import { PermissionDeniedComponent } from "./pages/permission-denied/permission-denied.component";
import { VideoStatusPageComponent } from "./pages/video-status-page/video-status-page.component";
import { StatisticsSearchPageComponent } from "./pages/statistics-search-page/statistics-search-page.component";
import { PlayerDetailPageComponent } from "./pages/player-detail-page/player-detail-page.component";
import { MatchDetailPageComponent } from "./pages/match-detail-page/match-detail-page.component";
import { TeamDetailPageComponent } from "./pages/team-detail-page/team-detail-page.component";
import { TeamCheckPageComponent } from "./pages/team-check-page/team-check-page.component";
import { TeamCheckGuard } from "./features/video/controller/team-check.guard";
import { StatsAiTeamPageComponent } from "./pages/stats-ai-team-page/stats-ai-team-page.component";
import { VideoUploadStore } from "./pages/upload-video/store/upload.store";

// TODO: Mover a guards.
export const unsavedChangesGuard: CanDeactivateFn<UploadVideoComponent> = () => {
  const store = inject(VideoUploadStore);
  if (store.totalVideos() > 0 && !store.uploadFinished() && !store.isUploadingAll()) {
    return window.confirm('Tienes videos en la cola que no se han subido. ¿Seguro que quieres salir y perderlos?');
  }
  if (store.isUploadingAll() && !store.uploadFinished()) {
    return window.confirm('Se están subiendo videos. Si sales, la subida en segundo plano podría detenerse y corromperse. ¿Seguro que quieres salir?');
  }
  return true;
};

const routes: Routes = [
  { path: '', redirectTo: '/analysis', pathMatch: 'full' },
  { path: 'home', redirectTo: '/analysis', pathMatch: 'full' },
  { path: 'login', component: LoginPageComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'after-login', component: AfterLoginComponent },
  { path: 'permission-denied', component: PermissionDeniedComponent },
  // PermissionGuard a las rutas específicas

  {
    path: 'analysis',
    component: AnalysisComponent,
    canActivate: [WiseIdAuthGuard, PermissionGuard],
    data: { permission: 'canReadAnalysis' }
  },
  {
    path: 'performance',
    component: PerformanceComponent,
    canActivate: [WiseIdAuthGuard, PermissionGuard],
    data: { permission: 'canReadPerformance' }
  },
  {
    path: 'health',
    component: HealthComponent,
    canActivate: [WiseIdAuthGuard, PermissionGuard],
    data: { permission: 'canReadHealth' }
  },
  {
    path: 'admin',
    component: AdminPageComponent,
    canActivate: [WiseIdAuthGuard, PermissionGuard],
    data: { permission: 'isAdmin' }
  },
  {
    path: 'upload',
    component: UploadVideoComponent,
    canActivate: [WiseIdAuthGuard, PermissionGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { permission: 'canUploadVideo' }
  },
  {
    path: 'statistics',
    component: StatisticsSearchPageComponent,
    canActivate: [WiseIdAuthGuard],
  },

  // Rutas que solo requieren estar logueado, pero no un permiso específico
  // TODO: Bloqueamos profile de momento.
  { path: 'profile', component: ProfileComponent, canActivate: [() => false] /*[WiseIdAuthGuard]*/ },
  { path: 'watch/:id', component: VideoWatchPageComponent, canActivate: [WiseIdAuthGuard, TeamCheckGuard] },
  { path: 'statistics/player/:id', component: PlayerDetailPageComponent, canActivate: [WiseIdAuthGuard] },
  { path: 'statistics/match/:id', component: MatchDetailPageComponent, canActivate: [WiseIdAuthGuard] },
  { path: 'statistics/team/:id', component: TeamDetailPageComponent, canActivate: [WiseIdAuthGuard] },
  { path: 'statistics/team-ai/:id', component: StatsAiTeamPageComponent, canActivate: [WiseIdAuthGuard] },
  { path: 'team-check/:id', component: TeamCheckPageComponent, canActivate: [WiseIdAuthGuard] },
  // A vista de asignarle algún permiso.
  { path: 'video-status', component: VideoStatusPageComponent, canActivate: [WiseIdAuthGuard] },

  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
